import axios from "axios";

export function GetFileFromUrl(url) {
    return axios({
        method: "GET",
        url,
        validateStatus: null,
        responseType: "blob"
    });
}